<template>
  <div>
    <i class="dx-icon dx-icon-comment"></i>
  </div>
</template>

<script>
export default {
  name: "GcCommentIcon",
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
